import axios from 'axios';
import { createNamespacedHelpers } from 'vuex';
import { update } from 'lodash';

const state = {
  isLoading: false,
  isSaving: false,
  state: 'none', // none | showing | creating | editing,
  all: [],
  enterpriseSelected: null,
  enterprise: {
    id: null,
    name: '',
    payroll_type: null,
    payroll_categories: []
  },
}

const getters = {
  /* enterpriseSelected(state) {
    if (state.selected === null) return null;

    return state.all.find(e => e.id === state.selected);
  } */
}

const mutations = {
  startLoading(state) {
    state.isLoading = true;
  },
  loadEnterprisesSuccess(state, payload) {
    state.all = payload;
    state.isLoading = false;
  },
  startSaving(state) {
    state.isSaving = true;
  },
  saveEnterpriseSuccess(state, payload) {
    state.all.push(payload);
    state.isSaving = false;
  },
  selectEnterprise(state, enterprise) {
    state.state = 'showing';
    state.enterpriseSelected = enterprise;
  },
  startCreate(state) {
    state.state = 'creating';
  },  
  startEdit(state) {
    state.state = 'editing';

    state.enterprise.id = state.enterpriseSelected.id;
    state.enterprise.name = state.enterpriseSelected.name;
    state.enterprise.payroll_type = state.enterpriseSelected.payroll_type.type;
    state.enterprise.payroll_categories = state.enterpriseSelected.payroll_categories.map(pc => pc.id);
  },
  reset(state) {
    state.state = state.enterprise.id === null ? 'none' : 'showing';
    state.enterprise.id = null;
    state.enterprise.name = '';
    state.enterprise.payroll_type = null;
    state.enterprise.payroll_categories = [];
  },
  updateName(state, name) {
    state.enterprise.name = name;
  },
  updatePayrollType(state, payrollType) {
    state.enterprise.payroll_type = payrollType;
  },
  updatePayrollCategories(state, payrollCategories) {
    state.enterprise.payroll_categories = payrollCategories;
  }
}

const actions = {
  async loadAll({ commit }, { params }) {
    commit('startLoading');
    let response = await axios.get(`/api/enterprises`, {
      params: params
    });
    commit('loadEnterprisesSuccess', response.data.data);
  },
  async save({ commit }, enterprise) {
    commit('startSaving');
    let response = await axios.post('/api/enterprises', enterprise);
    commit('saveEnterpriseSuccess', response.data);
  },
  async update({ commit }, enterprise) {
    // Antes validar si se va a guardar o actualizar
  },
  startCreateEnterprise({ state, commit, dispatch }) {
    state.enterpriseSelected = null;
    commit('reset');
    commit('startCreate');
    dispatch('payrollTypes/loadAll', null, { root: true });
    dispatch('payrollCategories/loadAll', null, { root: true });
  },
  startEditEnterprise({ commit, dispatch }) {
    commit('startEdit');
    dispatch('payrollTypes/loadAll', null, { root: true });
    dispatch('payrollCategories/loadAll', null, { root: true });
  }
}

export const {
  mapState: mapEnterprisesState,
  mapGetters: mapEnterprisesGetters,
  mapMutations: mapEnterprisesMutations,
  mapActions: mapEnterprisesActions
} = createNamespacedHelpers('enterprises');

export default {
  namespaced: true, 
  state,
  getters,
  mutations,
  actions,
};
